module.exports = __webpack_public_path__ + "static/media/29FUNOV4.54ec73d8.jpg";